import { toast } from 'react-toastify';

// One consistent feedback location for the whole app.
const baseOptions = {
  position: 'top-center',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
  newestOnTop: true,
};

const push = (type, message) => {
  // Keep feedback in one place and prevent duplicate stacked messages.
  toast.dismiss();
  toast[type](message || (type === 'success' ? 'Success' : 'Something went wrong'), baseOptions);
};

export const showSuccess = (message) => push('success', message);
export const showError = (message) => push('error', message);
export const showInfo = (message) => push('info', message);
